// Global variable that contains a list of all variants for a product,
// based on the variant that was selected
const VARIANTS = {};

const addToCartButtonSelector = ".btn-add-to-cart";
const addToCartErrorSelector = ".add-to-cart-error";
const productRadiosDeselectable = $(".product-variants-container").data("deselectable");
const $productListItem = $(".product-variants-container .form-check");

/**
 * On page load creates event listeners:
 * Creates event listener for variant and runs onVariantClick function
 * Creates event listener for add to cart button and runs
 * onAddToCartClick function
 */
$(() => {
  $("[data-id]").on("click", onVariantClick);
  $(addToCartButtonSelector).on("click", onAddToCartClick);

  // checks the event.code for the spacebar & enter keys to trigger the getProductVariants function
  $productListItem.on("keydown", (event) => {
    const $eventCode = event.code;
    const $eventInput = $(event.currentTarget.firstElementChild);
    if($eventCode === "Space") { event.preventDefault(); } // stops the spacebar from scrolling the page
    if($eventCode === "NumpadEnter" || $eventCode === "Enter" || $eventCode === "Space") {
      $eventInput.prop("checked", true);
      getProductVariants($eventInput);
    }
  });

  // TODO: test-specific logic for defining the test cookie
  // this sets the "Continue shopping" button on the empty cart page
  const releaseVariantIds = golo.readCookie("releaseVariantIds");
  if (!releaseVariantIds) {
    golo.setCookie("releaseVariantIds", JSON.stringify([]));
  }
  localStorage.setItem("golo-shop-variant", "base");

  populateExistingCart();
});

/**
 * When variants on the page are clicked it triggers the
 * getProductVariants function
 *
 * @param {Element} event - on click event
 */
const onVariantClick = (event) => {
  getProductVariants($(event.currentTarget));
};

/**
 * Gets the total price for all items in VARIANTS object. If the product is a
 * QV product, the quantity will be set to 1 for this calculation. This
 * quantity may be different than what is represented in the {@link VARIANTS}
 * object.
 */
const getTotalPrice = () => {
  let totalPrice = 0;
  for (const key of Object.keys(VARIANTS)) {
    // if the product is a QV product, the quantity should be set to 1
    const isQv = $(`[data-id="${key}"]`).data("qv") === "true";
    const itemQuantity = isQv ? 1 : VARIANTS[key].quantity;

    const itemPrice = VARIANTS[key].price;
    const subtotalPrice = itemQuantity * itemPrice;
    totalPrice += subtotalPrice;
  }
  return totalPrice;
};

/**
 * Updates the subtotal values on the UI
 *
 * @param {*} subtotal - subtotal amount for items that are selected
 */
const updateSubtotalElement = (subtotal) => {
  // Updates subtotal price for items selected on the UI
  $(".grand-total-price").val("$" + subtotal.toFixed(2));
  // Updates price for Buy Now Pay Later option
  $(".bnpl__container").attr("data-pp-amount", subtotal);
};

/**
 * Adds the specified items to the cart on clicking the add to cart button
 */
const onAddToCartClick = () => {
  $(addToCartErrorSelector).addClass("hide");
  const updates = Object
    .entries(VARIANTS)
    .filter((v) => v[1].quantity >= 1)
    .reduce((acc, [variantId, variantInfo]) => {
      acc[variantId] = variantInfo.quantity;
      return acc;
    }, {});

  if (Object.keys(updates).length > 0) {
    golo.client.ajax.cart
      .update(updates)
      .then(res => res.data)
      .then(() => {
        // TODO: remove hard-coded section when Release logic is moved to new
        // Shopify client
        addReleaseCookie(updates);

        $(addToCartErrorSelector)
          .html(
            '<img class="spinner" src="//cdn.shopify.com/s/files/1/0080/6148/5119/files/tail-spin.svg" width="20">'
          )
          .attr("data-processing", true);
        $(addToCartButtonSelector).html("Success!");
        return (window.location.href = $(addToCartButtonSelector).data(
          "redirect"
        ));
      })
      .catch((err) => {
        console.error(err);
        golo.toast(
          'Sorry, we experienced an error. Please contact us to place your order by phone: <a href="tel:18885304656">888-530-GOLO(4656)</a>.',
          {
            title: "Error!",
            state: "error",
          }
        );
      });
  } else {
    errorMessage = "Please choose a quantity of Release above.";
    $(addToCartErrorSelector).html(errorMessage).removeClass("hide");
  }
};

/**
 * Reset the checkout button behavior on Safari when reaching the page
 * via the back button
 * @param {*} event - Gets the event returned from on page show
 */
window.onpageshow = (event) => {
  if (event.persisted) {
    $(".btn-add-to-cart").removeAttr("data-processing").html("Add to Cart");
  }
};

/**
 * Populates the page with the existing cart data (if applicable.)
 */
const populateExistingCart = () => {
  golo.client.ajax.cart.get()
    .then(res => res.data)  
    .then((cart) => {
      // select inputs and change buttons for variants in cart
      cart.items.forEach((item) => {
        const $variantInput = $(`[data-id="${item.variant_id}"]`);
        $variantInput.prop("checked", true); // check the input
        getProductVariants($variantInput);
      });
  });
};

/**
 * Gets the variantId, productId, as well as list of all
 * variant's within the product. Displays the subtotal
 * and adds the product to the cart if the Add to Cart
 * button is selected.
 *
 * @param {*} selectedVariant - The variant that was selected
 */
const getProductVariants = (selectedVariant) => {
  // Gets the variant id of the selected variant
  const selectedVariantId = selectedVariant.data("id");
  // Gets the productId for the variant that was selected
  const productId = selectedVariant.parent("[data-product-id]", true);

  if (productRadiosDeselectable == "true" && VARIANTS[selectedVariantId] && VARIANTS[selectedVariantId]?.quantity >= 1) {
    // deletes the variant from the VARIANTS object if the quantity is greater than 1
    // and allows the radio to be unselected
    delete VARIANTS[selectedVariantId];
    selectedVariant.prop("checked", false);
  } else {
    // Gets all of the variants for the product
    const listOfVariants = productId.children("[data-id]");
    listOfVariants.each((quantity, element) => {
      const variantElement = $(element);
      const variantId = variantElement.data("id");

      if (variantId === selectedVariantId) {
        const variantItemPrice = parseFloat(variantElement.val() / 100);
        // Adds the variantId, quantity, and total to the VARIANTS object
        VARIANTS[variantId] = {
          quantity: quantity + 1,  // use the index as the quantity
          price: variantItemPrice,
        };
      } else if (VARIANTS[variantId]) {
        delete VARIANTS[variantId];
      }
    });
  }
  updateSubtotalElement(getTotalPrice());
  $(addToCartErrorSelector).addClass("hide");
};

/**
 * Adds the necessary cookie for tracking Release variants on this variant
 * test. The cookie is used to handle the Release quantities correctly on the
 * cart page.
 * TODO: Remove this hard-coded
 * @param {Record<string, number>} updates
 */
const addReleaseCookie = (updates) => {
  const releaseVariants = [];
  const $variants = $('[name="product"]');
  $variants.each((_, elem) => {
    const variantId = $(elem).data("id");
    if (golo.ShopifyClient.isRelease(variantId)) {
      releaseVariants.push(variantId);
    }
  })
  golo.setCookie("releaseVariantIds", JSON.stringify(releaseVariants));
};
